// Blocchi "a pagina intera" condivisi per il caricamento e l'errore di una
// vista. Prima ogni vista li riscriveva a mano (stesso markup, micro-differenze)
// — ora una sola fonte, così sono identici ovunque.

/** Vista in caricamento. */
export function Loading({ label = 'Carico…' }: { label?: string }) {
  return (
    <div className="view">
      <div className="view-pad">
        <div className="rs-muted rs-viewstate">{label}</div>
      </div>
    </div>
  );
}

/** Vista andata in errore. */
export function ErrorView({ detail }: { detail?: string | null }) {
  return (
    <div className="view">
      <div className="view-pad">
        <div className="rs-error">Errore{detail ? `: ${detail}` : ''}</div>
      </div>
    </div>
  );
}
